import { combineReducers } from 'redux';
import chemicalFillingPointReducer from './chemical/reducer';

export const fillingPointReducer = combineReducers({
    chemical: chemicalFillingPointReducer,
});